
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import FloatingWhatsApp from './components/feature/FloatingWhatsApp';
import BackToTop from './components/feature/BackToTop';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="min-h-screen flex flex-col">
        <Header />
        <div className="flex-1">
          <AppRoutes />
        </div>
        <Footer />
        <FloatingWhatsApp />
        <BackToTop />
      </div>
    </BrowserRouter>
  );
}

export default App;
